/**
 * AES util
 */
const CryptoJS = require('crypto-js')
export const AES = {
    encode: (params) => {
        let { data, param, key } = params
        let result = JSON.parse(JSON.stringify(data))
        param.forEach(ele => {
            let data = result[ele]
            key = CryptoJS.enc.Utf8.parse(key)
            let iv = key
            //加密
            let encrypted = CryptoJS.AES.encrypt(
                data,
                key,
                {
                    iv: iv,
                    mode: CryptoJS.mode.CBC,
                    padding: CryptoJS.pad.ZeroPadding
                })
            result[ele] = encrypted.toString();
        })
        return result
    },
    decode: (params) => {
        let { data, param, key } = params
        let result = JSON.parse(JSON.stringify(data))
        param.forEach(ele => {
            let data = result[ele]
            key = CryptoJS.enc.Utf8.parse(key)
            let iv = key
            let decrypt = CryptoJS.AES.decrypt(data, key, {
                iv: iv,
                mode: CryptoJS.mode.CBC,
                padding: CryptoJS.pad.ZeroPadding
            });
            let decryptedStr = decrypt.toString(CryptoJS.enc.Utf8);
            result[ele] = decryptedStr.toString();
        })
        return result
    },
}

/**
 * md5加密
 * @param {} ojb 
 */
import MD5 from 'md5-node'
export function md5(obj) {
    return MD5(obj)
}

/**
 * url参数转化为json对象，形式a=b(&c=d)
 * @param {*} url 
 */
export function urlQueryToObject(query) {
    if (!query) {
        return {}
    }
    return JSON.parse(
        '{"' +
        decodeURIComponent(query)
            .replace(/"/g, '\\"')
            .replace(/&/g, '","')
            .replace(/=/g, '":"') +
        '"}'
    )
}